module.exports = "/_next/static/images/7501738eecb520305249c61b4df4bb52-device-frame-dark@2x.png.webp";